import { useGetUsersQuery } from "./usersApiSlice"
import User from './User'
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
// import Welcome from "../auth/Welcome"

const UsersList = () => {
    useTitle('User-List')

    const {
        data: users,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUsersQuery('usersList', {
        pollingInterval: 60000,
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })

    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess) {

        const { ids } = users

        const tableContent = ids?.length && ids.map(userId => <User key={userId} userId={userId} />)

        content = (
            <>
                <div className="container w-[25rem] md:w-[80rem] h-[25rem] md:h-[37rem] mx-auto border-2 rounded-lg border-gray-400">
                    <table className="container">
                        <thead>
                            <tr className="underline md:text-2xl text-[19px]">
                                <th className="border border-slate-600 px-4 py-2">Username</th>
                                <th className="border border-slate-600 px-4 py-2">Roles</th>
                                <th className="border border-slate-600 px-4 py-2">Actions</th>
                            </tr>
                        </thead>
                        <tbody>      
                            {tableContent}
                        </tbody>        
                    </table>
                </div>
            </>
        )
    }

    return content
}
export default UsersList